import Cookies from 'js-cookie'
import React from 'react'
import styled from 'styled-components'
import { ICSuserTrack } from '../Common'


const ReqWrap = styled.div`
    border-radius: 8px;
    border: 1px solid #BB5213;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 400px;
    margin-top: 15px;
    margin-bottom: 20px;

    @media screen and (max-width: 767px){
      width: 310px;
    }
`
const AccGuest = styled.div`
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
  color: #BB5213;
  padding: 0px 20px;
  border-right: 1px solid #BB5213;
  cursor: pointer;
  border-radius: 8px 0px 0px 8px;

    &:hover{
    background-color: #FFF6F0;
  }
`
const Login = styled.div`
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
  color: #BB5213;
  padding: 0px 20px;
  cursor: pointer;
  border-radius: 0px 8px 8px 0px;

  &:hover{
    background-color: #FFF6F0;
  }
`

export default function RequestDemoField({ showSection, setShowSection, resetErrors, userEmailRef }) {

  const changeSection = (type) => {
    setShowSection(type);
    resetErrors();
    userEmailRef.current.value = '';

    let message = 'Clicked on Login button';
    if (type == 'guest') {
      message = 'Clicked on Access as guest';
    }

    ICSuserTrack('', message, '/signin.html', 'Guest login', '', Cookies.get('accessid'));
  }

  return (
    <div>
      <ReqWrap>
        <AccGuest
          onClick={() => changeSection('guest')}
          style={showSection == 'guest' ? { background: "#FFF6F0" } : {}}
        >
          Access as Guest
        </AccGuest>

        <Login
          onClick={() => changeSection('login')}
          style={showSection == 'login' ? { background: "#FFF6F0" } : {}}
        >
          Login
        </Login>

      </ReqWrap>

    </div>
  )
}
